import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class Sounds extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="sounds">
        <Header
          props={this.props}
        />
        <div className="sounds-headline">
            <i>for-tunes</i> <br />
          <div className="sounds-subline">
            New tunes to tunes to
            <br />
          </div>
          (note to self, come up with a better title)
        </div>
        <div className="sounds-text">
         <p></p>
        </div>
        <div className="sounds-spotify">
          <iframe title="spotify" src="https://open.spotify.com/embed/user/spotify/playlist/6alzzXRuxvRKBpmlAoCaS9" width="500" height="580"></iframe>
        </div>
      </div>
    );
  }
}

export default Sounds;

